import cx from 'classnames'
import _ from '@/utils/lodash-optimized'

import './styles.scss'

const PAGINATION_LENGTH = 9

const RenderChevron = ({ direction, onClick }) => (
  <div className={cx('chevron')}>
    <button
      title={`Go to the ${direction === 'right' ? 'next' : 'previous'} page`}
      onClick={onClick}
      className='chevron-button'
    >
      <i className={`fa fa-chevron-${direction}`} />
    </button>
  </div>
)

const RenderChevrons = ({ direction, onClick }) => (
  <div className={cx('chevron')}>
    <button
      title={`Go to the ${direction === 'right' ? 'last' : 'first'} page`}
      onClick={onClick}
      className='chevron-button'
    >
      <i className={`fa fa-chevron-${direction}`} />
      <i className={`fa fa-chevron-${direction}`} />
    </button>
  </div>
)

export const Pagination = ({ onChange, totalPages, currentPage }) => {
  const buildPagesRange = current => {
    let shiftValue
    let wingLength

    if (totalPages >= PAGINATION_LENGTH) {
      wingLength = Math.floor((PAGINATION_LENGTH + 1) / 2)
    } else {
      wingLength = Math.floor(totalPages / 2)
    }

    const rightWing = _.range(current, current + wingLength)
    const leftWing = _.range(current - wingLength + 1, current)
    const bothWings =
      totalPages >= PAGINATION_LENGTH
        ? _.concat(leftWing, rightWing)
        : _.range(1, totalPages + 1)

    if (bothWings[0] < 1) {
      shiftValue = Math.abs(bothWings[0]) + 1
    } else if (_.last(bothWings) > totalPages) {
      shiftValue = totalPages - _.last(bothWings)
    } else {
      shiftValue = 0
    }

    return bothWings.map(i => i + shiftValue)
  }

  const renderPage = i => {
    const pageClass = cx({
      active: i === currentPage || undefined
    })

    const handleOnChange = (index, e) => {
      e.preventDefault()
      onChange(index)
    }

    return (
      <div
        key={`pagination${i}`}
        className={pageClass}
      >
        <button
          type='button'
          className='page-button'
          onClick={e => handleOnChange(i, e)}
        >
          {i}
        </button>
      </div>
    )
  }

  const nextPage = () => {
    onChange(currentPage < totalPages ? currentPage + 1 : totalPages)
  }

  const prevPage = () => {
    onChange(currentPage > 1 ? currentPage - 1 : 1)
  }

  const lastPage = () => {
    onChange(totalPages)
  }

  const firstPage = () => {
    onChange(1)
  }

  if (totalPages <= 0) {
    return null
  }

  return (
    <div className='nh-pagination'>
      {currentPage !== 1 && (
        <div className='pagination-button'>
          {currentPage > 5 && totalPages > 9 && (
            <RenderChevrons
              direction='left'
              onClick={firstPage}
            />
          )}

          <RenderChevron
            direction='left'
            onClick={prevPage}
          />

        </div>
      )}

      <div className='pages'>
        {buildPagesRange(currentPage).map(i => renderPage(i))}
      </div>

      {currentPage !== totalPages && (
        <div className='pagination-button'>
          <RenderChevron
            direction='right'
            onClick={nextPage}
          />

          {totalPages > 9 && totalPages - currentPage > 4 && (
            <RenderChevrons
              direction='right'
              onClick={lastPage}
            />
          )}
        </div>
      )}

    </div>
  )
}
